import React, { useEffect, useState } from "react";
import { connectHits } from "react-instantsearch-core";

import SearchPost from "../../../Components/SearchPost";
import { ListItem } from "@mui/material";


function MoviesHits({ hits }) {

  return (
    <>
      {hits.map((hit, index) => {
        return (
          <ListItem key={hit["uid"]}>
            <SearchPost hit={hit} index={index}  />
          </ListItem>
        )
      })}
    </>
  );
}

export default connectHits(MoviesHits);
